import React, { useState } from 'react';

import { updateProfile } from 'common/api/SsoApi';
import TOSValidation, {
  TOSValidationModalParams
} from 'common/components/TOSValidationModal/Component';
import { ModalNames } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import { CloseModal } from 'common/module/ui/lazy-modal/types';
import eventEmitter, { EventsTypes } from 'common/services/events/eventEmitter';
import trans from 'common/tools/translations/trans';

type TOSValidationModalProps = TOSValidationModalParams & {
  closeModal: CloseModal;
};
const TOSValidationModal = ({
  closeModal,
  showAdConsentCheckbox,
  showPixelConsentCheckbox
}: TOSValidationModalProps) => {
  const [submitting, setSubmitting] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const handleSubmit = async (
    termsOfService?: boolean,
    adConsent?: boolean,
    pixelConsent?: boolean
  ) => {
    setSubmitting(true);

    try {
      await updateProfile({
        cguValidated: termsOfService,
        ...(adConsent !== undefined && { adConsent }),
        ...(pixelConsent !== undefined && { pixelConsent: pixelConsent })
      });
      eventEmitter.emit(EventsTypes.UPDATE_USER_PROFILE);
      closeModal();
    } catch (e) {
      setSubmitting(false);
      setErrorMessages([trans('userspace.sign-in.error.internal')]);
    }
  };
  return (
    <TOSValidation
      errorMessages={errorMessages}
      onSubmit={handleSubmit}
      showAdConsentCheckbox={showAdConsentCheckbox}
      showPixelConsentCheckbox={showPixelConsentCheckbox}
      submitting={submitting}
    />
  );
};
export default buildReactDomModalModule<
  TOSValidationModalParams | null | undefined
>(ModalNames.TOS_VALIDATION_MODAL, (params, closeModal) => (
  <TOSValidationModal
    closeModal={closeModal}
    showAdConsentCheckbox={params?.showAdConsentCheckbox}
    showPixelConsentCheckbox={params?.showPixelConsentCheckbox}
  />
));
